import { supabase } from '@/lib/supabase';
export const downloadAttachment = async (
  userId: string,
  transactionId: string,
  fileName: string,
  originalName: string
) => {
  try {
    const filePath = `users/${userId}/transactions/${transactionId}/attachments/${fileName}`;
    
    // Get file from Supabase Storage
    const { data, error } = await supabase.storage
      .from('attachments')
      .download(filePath);
    
    if (error) {
      throw error;
    }
    
    if (!data) {
      throw new Error('File not found');
    }

    // For preview (images, PDFs)
    if (originalName.match(/\.(jpg|jpeg|png|gif|pdf)$/i)) {
      const { data: urlData } = supabase.storage
        .from('attachments')
        .getPublicUrl(filePath);
      
      if (urlData && urlData.publicUrl) {
        window.open(urlData.publicUrl, '_blank');
        return;
      }
    }

    // For download (other file types)
    const blob = data;
    const downloadUrl = window.URL.createObjectURL(blob);
    
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = originalName; // Use original filename for download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);
  } catch (error) {
    console.error('Error downloading file:', error);
    throw new Error('Failed to download file. Please try again.');
  }
};

export const previewAttachment = async (
  userId: string,
  transactionId: string,
  fileName: string
) => {
  try {
    const filePath = `users/${userId}/transactions/${transactionId}/attachments/${fileName}`;
    
    // Get public URL from Supabase Storage
    const { data, error } = supabase.storage
      .from('attachments')
      .getPublicUrl(filePath);
    
    if (error) {
      throw error;
    }
    
    if (!data || !data.publicUrl) {
      throw new Error('Failed to get preview URL');
    }
    
    return data.publicUrl;
  } catch (error) {
    console.error('Error getting preview URL:', error);
    throw new Error('Failed to get preview URL. Please try again.');
  }
};
